import { createFileRoute } from '@tanstack/react-router'

import { CarriersPage } from '#/modules/fmcsa/carriers-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/fmcsa-carriers/')({
  component: CarriersPage,
  validateSearch: validateListSearch,
})
